import { DatePicker, ConfigProvider } from "antd";
import type { ComponentProps } from "react";
import { AvailableDot } from "components/DateWithTimePicker/styles";
import { Dayjs } from "dayjs";
import dayjs from "dayjs";
import locale from "antd/es/locale/pl_PL";
import "dayjs/locale/pl";

type Props = ComponentProps<typeof DatePicker> & {
    availableDays?: string[];
    onMonthChange?: (month: string) => void;
};

export default function DatePickerWithAvailableDays({ availableDays = [], onMonthChange, onPickerValueChange, ...rest }: Props) {
    return (
        <ConfigProvider locale={locale}>
            <DatePicker
                inputReadOnly
                minDate={dayjs()}
                {...rest}
                onPickerValueChange={(dayjsDate, info) => {
                    onMonthChange?.(dayjsDate.format('YYYY-MM'));
                    onPickerValueChange?.(dayjsDate, info);
                }}
                cellRender={(current, info) => {
                    if (info.type !== 'date') return info.originNode;
                    const dateStr = (current as Dayjs).format('YYYY-MM-DD');
                    const hasSlots = availableDays.includes(dateStr);
                    return (
                        <div className="ant-picker-cell-inner">
                            {(current as Dayjs).date()}
                            {hasSlots && <AvailableDot />}
                        </div>
                    );
                }}
            />
        </ConfigProvider>
    );
}
